function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgContactOwner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.632,
    height: 14.341,
    viewBox: "0 0 11.632 14.341",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.916 5.342a3.215 3.215 0 0 0-6.428 0 3.215 3.215 0 0 0 6.428 0zm-5 0a1.787 1.787 0 0 1 3.571 0 1.787 1.787 0 0 1-3.571 0zm-3.5 6.927-.357 1.357a2.108 2.108 0 0 0 .357 1.928 2.173 2.173 0 0 0 1.714.786h7.142a1.911 1.911 0 0 0 1.643-.857 2.108 2.108 0 0 0 .357-1.928l-.356-1.355a3.888 3.888 0 0 0-3.785-3H8.274a4.016 4.016 0 0 0-3.856 3.07zm1 1.714.357-1.357a2.642 2.642 0 0 1 2.5-2h2.857a2.642 2.642 0 0 1 2.5 2l.357 1.357a.88.88 0 0 1-.143.714.862.862 0 0 1-.571.214H6.132a.514.514 0 0 1-.5-.286.576.576 0 0 1-.214-.641z",
    transform: "translate(-3.851 -2.1)",
    style: {
      fill: "#c4c4c4",
      stroke: "#c4c4c4",
      strokeWidth: ".2px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactOwner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contactOwner.ffe8522e.svg";
export { ForwardRef as ReactComponent };